<template>
  <div class="index-wrap">
    <div class="index-nav">
      <h1>智能公共法律服务系统（民法典婚姻家庭编版）</h1>
      <p>北京大学法律人工智能实验室</p>
      <!-- <p>秘塔科技</p> -->
      <el-button size= "small" @click="goToQuestionsPage">立即咨询</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    goToQuestionsPage: function () {
      this.$router.push({path: '/question'})
    }
  }
}
</script>

<style lang="less" scoped>
  .index-wrap {
    background-image: url(../../static/img/back.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height: 100vh;
    position: relative;
    .index-nav {
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 8rem;
      h1 {
        font-size: 40px;
        margin-bottom: 6rem;
      }
      .el-button {
        padding: 8px 30px;
        margin-top: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/Index.vue